// src/pages/InstallPage/InstallPage.tsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BackgroundCanvasWithoutRadar from '../../widgets/canvas/BackgroundCanvasWithoutRadar';
import { platformIcons } from '../../assets/images/platformIcons';
import Loader from '../../widgets/Loader/Loader';
import './InstallPage.scss';

interface PlatformCardProps {
    icon: string;
    platform: string;
    onClick?: () => void;
}

const PlatformCard: React.FC<PlatformCardProps> = ({ icon, platform, onClick }) => {
    return (
        <div className="platform-card" onClick={onClick}>
            <img src={icon} className="platform-icon" alt={platform} />
            <div className="platform-label">Инструкция</div>
            <div className="platform-name">для {platform}</div>
        </div>
    );
};

function InstallPage() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const tg = (window as any).Telegram?.WebApp;
        if (tg) {
            tg.ready();
            tg.expand();
            tg.setHeaderColor?.('#000000');
            tg.setBackgroundColor?.('#000000');
        }

        // Имитация загрузки или реальная проверка
        const timer = setTimeout(() => {
            setLoading(false);
        }, 500);

        return () => clearTimeout(timer);
    }, []);

    const handlePlatformClick = (platform: string) => {
        const platformMap: Record<string, string> = {
            'iOS': 'ios',
            'Android': 'android',
            'macOS': 'macos',
            'Windows': 'windows'
        };

        const path = platformMap[platform];
        if (path) {
            navigate(`/instructions/${path}`);
        }
    };

    const handleOtherPlatforms = () => {
        navigate('/other-platforms');
    };

    if (loading) {
        return (
            <div className="tg-app">
                <BackgroundCanvasWithoutRadar />
                <div className="install-page loading">
                    <div className="install-loader"><Loader /></div>
                </div>
            </div>
        );
    }

    return (
        <div className="tg-app">
            <BackgroundCanvasWithoutRadar />

            <div className="install-page">
                {/* Герой блок */}
                <div className="install-hero">
                    <div className="hero-icon">
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                            <rect x="2" y="3" width="20" height="18" rx="2" stroke="currentColor"/>
                            <path d="M8 21h8" stroke="currentColor" strokeLinecap="round"/>
                            <path d="M12 17v4" stroke="currentColor" strokeLinecap="round"/>
                        </svg>
                    </div>
                    <div className="hero-title">Установка на другом устройстве</div>
                    <div className="hero-subtitle">Выберите платформу для подключения на другом устройстве</div>
                </div>

                {/* Сетка с платформами 2x2 */}
                <div className="platforms-grid">
                    <PlatformCard
                        icon={platformIcons.ios}
                        platform="iOS"
                        onClick={() => handlePlatformClick('iOS')}
                    />

                    <PlatformCard
                        icon={platformIcons.android}
                        platform="Android"
                        onClick={() => handlePlatformClick('Android')}
                    />

                    <PlatformCard
                        icon={platformIcons.macos}
                        platform="macOS"
                        onClick={() => handlePlatformClick('macOS')}
                    />

                    <PlatformCard
                        icon={platformIcons.windows}
                        platform="Windows"
                        onClick={() => handlePlatformClick('Windows')}
                    />
                </div>

                {/* Кнопка "Другие платформы" */}
                <button className="other-platforms-button" onClick={handleOtherPlatforms}>
                    Другие платформы
                </button>
            </div>
        </div>
    );
}

export default InstallPage;